"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STORAGE_URL_IPFS_PREFIX = exports.STORAGE_URL_FILECOIN_PREFIX = exports.STORAGE_TYPE_IPFS = exports.STORAGE_TYPE_FILECOIN = exports.LIGHTHOUSE_ENDPOINT = void 0;
const LIGHTHOUSE_ENDPOINT = exports.LIGHTHOUSE_ENDPOINT = "https://gateway.lighthouse.storage/ipfs";
const STORAGE_TYPE_IPFS = exports.STORAGE_TYPE_IPFS = "ipfs";
const STORAGE_TYPE_FILECOIN = exports.STORAGE_TYPE_FILECOIN = "filecoin";
const STORAGE_URL_IPFS_PREFIX = exports.STORAGE_URL_IPFS_PREFIX = "ipfs://";
const STORAGE_URL_FILECOIN_PREFIX = exports.STORAGE_URL_FILECOIN_PREFIX = "filecoin://";